import { normalizePhone } from "modules/ui";

export const arePhonesEqual = (phoneA: unknown, phoneB: unknown) => {
  return (
    typeof phoneA === "string" &&
    typeof phoneB === "string" &&
    normalizePhone(phoneA) === normalizePhone(phoneB)
  );
};
